import React from 'react'
import loader from "../assets/images/loader.gif"
export default function Loader(props) {
  return (
    <div className='loader' style={{display:props.show===1?"flex":"none", zIndex:"9999999999"}}>
        <img src={loader} width="50px" height="50px" alt='loader'/>
    </div>
  )
}
